import { render, staticRenderFns } from "./BankEditHistoryItem.vue?vue&type=template&id=2e98b7c4"
import script from "./BankEditHistoryItem.vue?vue&type=script&lang=ts"
export * from "./BankEditHistoryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e98b7c4')) {
      api.createRecord('2e98b7c4', component.options)
    } else {
      api.reload('2e98b7c4', component.options)
    }
    module.hot.accept("./BankEditHistoryItem.vue?vue&type=template&id=2e98b7c4", function () {
      api.rerender('2e98b7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/BankEditHistoryItem.vue"
export default component.exports